import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onResizeBind = this.onResize.bind(this)

        this.members = JSON.parse(this.getData('members'))
        this.membersMax = this.getData('size')
        this.itemsPerLine = this.getData('items')

        this.speed = 2

        // UI
        this.$el = this.el
        this.$lines = this.$('line')
        this.$items = this.$('item')
        this.$marquees = this.$('marquee')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
        this.members = this.shuffle(this.members)

        if (this.members.length > this.membersMax) {
            this.members = this.members.splice(0, this.membersMax)
        }

        this.populate()

        this.addTicker = () => this.translate()
        gsap.ticker.add(this.addTicker)

        this.$el.removeAttribute('data-trombinoscope-members')
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener("resize", this.onResizeBind)
    }

    unbindEvents() {
        window.removeEventListener("resize", this.onResizeBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        let index = 0;
        while (index < this.$marquees.length) {
            this.resetTransform(this.$marquees[index])
            index++;
        }
    }

    ///////////////
    // Methods
    ///////////////
    populate() {
        this.$lines.forEach((line, lineIndex) => {

            const first = lineIndex * this.itemsPerLine
            const last = first + this.itemsPerLine
            const itemsToAdd = this.members.slice(first, last)

            itemsToAdd.forEach((item, itemIndex) => {
                const realIndex = lineIndex * this.itemsPerLine + itemIndex

                // Main visual
                this.$('visual', this.$lines[lineIndex])[itemIndex].setAttribute('data-src', this.members[realIndex].image)
                this.$('visual', this.$lines[lineIndex])[itemIndex].setAttribute('alt', this.members[realIndex].alt)
                // Hover visual
                if (typeof this.members[realIndex].image_hover !== 'undefined') {
                    this.$('visual_hover', this.$lines[lineIndex])[itemIndex].setAttribute('data-src', this.members[realIndex].image_hover)
                    this.$('visual_hover', this.$lines[lineIndex])[itemIndex].setAttribute('alt', this.members[realIndex].alt + ' hover')
                }
                this.$('name', this.$lines[lineIndex])[itemIndex].innerHTML = this.members[realIndex].name
                this.$('job', this.$lines[lineIndex])[itemIndex].innerHTML = this.members[realIndex].job
            })

        })
    }

    translate() {
        let delta = gsap.ticker.deltaRatio()

        this.$marquees.forEach(($marquee) => {
            let distance = this.getTranslate($marquee) + $marquee.dataset.speed * delta / 2

            if(Math.abs(distance) >= $marquee.offsetWidth) {
                this.resetTransform($marquee)
                distance = 0
            }

            $marquee.style.transform = `translate3d(${distance}px, 0, 0)`;

            let index = 0;
            while (index < $marquee.children.length) {

                const item = $marquee.children[index]
                const itemWidth = item.clientWidth

                let itemOffset
                if ($marquee.dataset.speed < 0) {
                    itemOffset = item.getBoundingClientRect().right
                } else {
                    itemOffset = window.innerWidth - item.getBoundingClientRect().left
                }

                if (itemOffset < 0) {
                    this.translateItem($marquee.children[index], $marquee);
                }

                index++;
            }
        })
    }

    translateItem($item, $marquee) {
        const translate = $marquee.dataset.speed < 0 ? $marquee.offsetWidth : -1 * $marquee.offsetWidth
        $item.style.transform = `translate3d(${translate}px, 0, 0)`;
    }

    resetTransform($marquee) {
        let index = 0;
        while (index < $marquee.children.length) {
            $marquee.children[index].style.transform = "";
            index++;
        }
    }

    ///////////////
    // Utils
    ///////////////
    shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array
    }

    getTranslate(el) {
        const style = window.getComputedStyle(el)
        const matrix = new WebKitCSSMatrix(style.transform)
        return matrix.m41
    }
}
